import { useState, useCallback } from 'react'

export function useConfirm() {
  const [pending, setPending] = useState<{ message: string; onConfirm: () => void } | null>(null)

  const confirm = useCallback((message: string, onConfirm: () => void) => {
    setPending({ message, onConfirm })
  }, [])

  const handleConfirm = useCallback(() => {
    pending?.onConfirm()
    setPending(null)
  }, [pending])

  const handleCancel = useCallback(() => {
    setPending(null)
  }, [])

  return { pending, confirm, handleConfirm, handleCancel }
}
